export default function isCMSImage(url) {
  const datoURL = process.env.IMAGES_CMS_URL;
  const nubankCmsURL = process.env.NEXT_PUBLIC_IMAGES_NU_URL;
  const regexp = new RegExp(`https://(${datoURL}|${nubankCmsURL})`);
  return regexp.test(url);
}
